import { EventEmitter, Injectable } from '@angular/core';

import { Subject } from 'rxjs';

// NB this is component-scoped provided ONLY currently
@Injectable()
export class TicketFocusService extends Subject<string> {
    constructor() {
        super();
    }
    focus() {
        this.next();
    }

}
